import { InputCurrencyGroup } from "@finanedi.es/storybook"
import { useMemo } from "react"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { FieldTemplateOne } from "../../PlantillasBloquesTabla"

export const ResultadoLiquidacionAnual = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  watch: UseFormWatch<$TSMigrationFixMe>
}) => {
  const { t } = useTranslation()
  const values = watch()
  const casilla84Liq = useMemo(() => {
    const casilla65 = values?.casilla65 ? Number(values?.casilla65) : 0
    const casilla83 = 0
    const casilla658 = values?.resultLiqAnCasilla658
      ? Number(values?.resultLiqAnCasilla658)
      : 0
    const result = casilla65 + casilla83 + casilla658
    setValue("resultLiqAnCasilla84", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.casilla65, values?.resultLiqAnCasilla658])

  const fields: FieldTemplateOne[] = [
    {
      label: t("taxSummary.declaracion.resultadoLiquidacionAnual.box1"),
      code: "resultLiqAnCasilla658",
      inputNumber: "658",
      value: values?.resultLiqAnCasilla658,
    },
    {
      label: t("taxSummary.declaracion.resultadoLiquidacionAnual.box2"),
      code: "resultLiqAnCasilla84",
      inputNumber: "84",
      value: casilla84Liq,
      disabled: true,
    },
    {
      label: t("taxSummary.declaracion.resultadoLiquidacionAnual.box3"),
      code: "resultLiqAnCasilla659",
      inputNumber: "659",
      value: values?.resultLiqAnCasilla659,
    },
    {
      label: t("taxSummary.declaracion.resultadoLiquidacionAnual.box4"),
      code: "casilla85",
      inputNumber: "85",
      value: values?.casilla85,
      disabled: false,
    },
  ]

  const casilla86 = useMemo(() => {
    const casilla84 = values?.resultLiqAnCasilla84
      ? Number(values?.resultLiqAnCasilla84)
      : 0
    const casilla659 = values?.resultLiqAnCasilla659
      ? Number(values?.resultLiqAnCasilla659)
      : 0
    const casilla85 = values?.casilla85 ? Number(values?.casilla85) : 0
    const result = casilla84 + casilla659 - casilla85
    setValue("casilla86", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.resultLiqAnCasilla84,
    values?.resultLiqAnCasilla659,
    values?.casilla85,
  ])

  return (
    <div
      title='Liquidación anual'
      className='tw-w-full tw-px-6 tw-pb-6'
    >
      <div className='tw-flex tw-flex-col'>
        {fields.map((field) => (
          <div
            key={field.code}
            className='tw-grid tw-grid-cols-5 tw-items-center tw-gap-2 tw-border-b tw-border-gray-200 tw-py-3'
          >
            <div className='tw-col-span-4 tw-text-sm'>{field.label}</div>
            <div className='tw-col-span-1'>
              <InputCurrencyGroup
                suffix='€'
                value={typeof field.value === "number" ? field.value : 0}
                onChange={(value) => setValue(`${field.code}`, value)}
                placeholder='0,00'
                className='tw-w-full tw-h-full tw-text-sm'
                numberGroup={String(field.inputNumber)}
                disabled={field.disabled}
              />
            </div>
          </div>
        ))}

        <div className='tw-grid tw-grid-cols-5 tw-items-center tw-gap-2 tw-border-b tw-border-gray-200 tw-py-3'>
          <div className='tw-col-span-4 tw-text-sm tw-font-bold '>
            {t("taxSummary.declaracion.resultadoLiquidacionAnual.box5")}
          </div>
          <div className='tw-col-span-1'>
            <InputCurrencyGroup
              suffix='€'
              placeholder='0,00'
              className='tw-w-full tw-h-full tw-text-sm'
              numberGroup='86'
              value={casilla86}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  )
}
